<template>
  <div
    v-if="isNotCompleted"
    class="sticky-actions"
  >
    <naj-button
      class="incomplete-button"
      @click="showNotCompleteReasons"
    >
      <v-icon>mdi-information</v-icon>
      {{ local.bankruptcy.incompleteReasons.title }}
      <v-icon v-if="isExpanded">
        mdi-chevron-up
      </v-icon>
      <v-icon v-if="!isExpanded">
        mdi-chevron-down
      </v-icon>
    </naj-button>

    <v-expand-x-transition>
      <naj-box
        v-show="isExpanded"
        :title="local.bankruptcy.incompleteReasons.nots"
        :disable-collapsing="true"
        no-bottom-margin
        class="expand-card"
      >
        <div class="expand-card-content">
          <div class="h6">
            {{ local.common.dearApplicant }}
            <br>
            {{ local.bankruptcy.incompleteReasons.messageIncompleteReasons }}
          </div>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title
                v-for="(item, index) in replies"
                :key="index"
                class="text-wrap"
              >
                - {{ '  ' + item }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <div class="pull-left">
            <naj-button
              outlined
              @click="close"
            >
              {{ local.common.close }}
            </naj-button>
          </div>
        </div>
      </naj-box>
    </v-expand-x-transition>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { requestStatus, requestReplyTypes } from '@/helpers/enum';
import najBox from '@/components/shared/naj-box.vue';

const { mapState, mapActions, mapGetters } = createNamespacedHelpers('BankruptcyModule');

export default {
  components: { najBox },
  props: {
    requestObjectKey: {
      type: String,
      required: true,
      default: '',
    },
  },
  data() {
    return {
      isExpanded: false,
      requestReplyTypes,
      requestStatus,
    };
  },
  computed: {
    ...mapState({ replies: state => state.replies }),
    ...mapGetters([
      'isNewMode',
      'isNotCompleted',
    ]),
  },
  created() {
    this.getIncompleteReasons(this.requestObjectKey);
  },
  methods: {
    ...mapActions(['getIncompleteReasons']),
    showNotCompleteReasons() {
      this.isExpanded = !this.isExpanded;
    },
    close() {
      this.isExpanded = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/partials/_vars.scss';

.sticky-actions {
  position: fixed;
  left: 6px;
  top: 50%;
  z-index: 50;
  height: 0px;
  .v-button-wrapper.incomplete-button {
    transform: rotate(270deg);
    position: relative;
    right: 96px;

    .mdi-information {
      color: yellow;
    }
  }
  .expand-card {
    position: relative;
    float: left;
    bottom: 92px;
    width: 500px;
    height: 220px;
    .expand-card-content {
      height: 122px;
      overflow-y: auto;
    }
  }
}
</style>
